var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLowes = function SvgLowes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 80,
    viewBox: "0 0 175 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 175,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.955078 0.362701H174.387V79.968H0.955078V0.362701Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.463 19.5536H160.396V27.3792H174.387V80H0.922852V27.3792H14.9213V19.5536H42.8647L87.6637 0.362701L132.463 19.5536Z",
    fill: "#0042C2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.032 33.5462L129.028 42.0523L134.533 42.0614L135.68 33.5499L129.032 33.5462Z",
    fill: "#FFFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.914 41.9371C159.27 41.9371 159.591 41.9094 159.591 41.4785C159.591 41.1382 159.276 41.0737 158.986 41.0737H158.409V41.9371H158.914ZM158.409 43.4993H157.99V40.7153H159.049C159.702 40.7153 160.029 40.9606 160.029 41.5078C160.029 42.0086 159.721 42.2235 159.311 42.2742L160.1 43.4993H159.629L158.895 42.2934H158.409V43.4993ZM158.92 44.119C160.015 44.119 160.871 43.2657 160.871 42.1025C160.871 40.9606 160.015 40.0982 158.92 40.0982C157.815 40.0982 156.954 40.9606 156.954 42.1025C156.954 43.2657 157.815 44.119 158.92 44.119ZM156.47 42.1025C156.47 40.7153 157.592 39.6971 158.92 39.6971C160.235 39.6971 161.359 40.7153 161.359 42.1025C161.359 43.4993 160.235 44.5217 158.92 44.5217C157.592 44.5217 156.47 43.4993 156.47 42.1025Z",
    fill: "#FFFFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5956 62.5339V33.5462H20.6665V69.4395H40.8628V62.5339H28.5956Z",
    fill: "#FFFFFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.407 69.4395H127.277V62.527H116.375V58.0219H127.277V51.3675H116.375V46.8374H127.277V39.8966H108.407V69.4395Z",
    fill: "#FFFFFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0096 62.4966H58.9819V46.8379H52.0096V62.4966ZM66.9243 65.664C66.9243 67.7478 65.2374 69.4395 63.1547 69.4395H47.8379C45.7552 69.4395 44.0688 67.7478 44.0688 65.664V43.6683C44.0688 41.5856 45.7552 39.8966 47.8379 39.8966H63.1547C65.2374 39.8966 66.9243 41.5856 66.9243 43.6683V65.664Z",
    fill: "#FFFFFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9295 39.8966V62.5339H91.1423V39.8966H84.1684V62.5339H79.3844V39.8966H71.4404V65.664C71.4404 67.7478 73.13 69.4395 75.2132 69.4395H84.601C86.1844 69.4395 87.6575 68.3483 87.6575 66.7627C87.6575 68.3483 89.1311 69.4395 90.713 69.4395H100.102C102.185 69.4395 103.873 67.7478 103.873 65.664V39.8966H95.9295Z",
    fill: "#FFFFFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.12 58.2753L155.124 58.2758L155.073 58.175C155.043 58.1132 155.013 58.0508 154.979 57.9884L154.931 57.8913C153.673 55.3718 150.861 53.2652 146.33 51.4566L146.173 51.3942C145.272 51.0412 142.545 49.9734 142.244 48.2385C142.159 47.7542 142.356 46.991 142.897 46.5286C143.468 45.9457 144.346 45.6486 145.498 45.6486C147.344 45.6486 149.447 46.4049 150.531 46.8529C152.824 47.8044 154.832 48.6529 154.852 48.6614L155.051 48.7441V42.2977L154.985 42.2545C154.943 42.2257 150.61 39.4971 146.233 38.8683C145.729 38.8267 145.231 38.8044 144.754 38.8044C140.726 38.8044 137.675 40.2694 135.683 43.1553C134.015 45.5281 133.832 49.2785 135.251 52.0817C137.076 55.2481 140.002 56.5702 142.832 57.8508C144 58.3756 145.209 58.9222 146.335 59.5964L146.348 59.6033C147.626 60.3702 148.277 61.5436 148.008 62.5873C147.728 63.6673 146.491 64.3953 144.929 64.3953C144.716 64.3953 144.497 64.3793 144.288 64.3532L144.213 64.342C141.209 63.9244 135.115 61.654 135.051 61.631L134.857 61.558V68.6284L134.957 68.663C135.013 68.6833 140.913 70.6353 146.147 70.6353H146.151C149.009 70.6353 151.167 70.0588 152.563 68.9276C152.596 68.9014 155.795 66.3302 155.936 61.9542C155.977 60.7425 155.701 59.5052 155.12 58.2753Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173.867,
    height: 80,
    fill: "white",
    transform: "translate(0.922852)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLowes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lowes.62591291.svg";
export { ForwardRef as ReactComponent };